import { isRequiredText } from './utils';
/**
 * @deprecated TS化済 src/utils/validate/resources/registration/registration.ts
 */
const validateUseType = [isRequiredText('利用方法を選択してください')];
const validateDivision = [isRequiredText('登録区分を選択してください')];
/**
 * @deprecated TS化済 src/utils/validate/resources/registration/registration.ts
 */
const validateAssign = [
    (value) => value === true ? '' : '利用規約、プライバシポリシーに同意してください',
];
const validateDocumentConsultant = [
    (value) => value === true
        ? ''
        : '「コンサルティングサービスは提供していません」に同意してください',
];
export default {
    validateAssign,
    validateDivision,
    validateDocumentConsultant,
    validateUseType,
};
